import { roles } from '@/enums'

export default defineNuxtRouteMiddleware(async (to, _from) => {
  const user = useSupabaseUser()
  if (!user.value) {
    return navigateTo({ path: '/login', query: { redirect: to.fullPath } })
  }
  const schoolRoles = await useSchoolMemberships().load()
  const isLoggedIn = schoolRoles.find((schoolRole: SchoolRole) =>
    [roles.STUDENT, roles.TEACHER, roles.ADMIN, roles.GUARDIAN].includes(
      schoolRole.role,
    ),
  )
  if (!isLoggedIn) {
    return navigateTo({
      path: '/login',
      query: { redirect: to.fullPath },
    })
  }
})
